import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppState, ShowRequest} from '../../core';

import { DriveTestSeqService, PathTestService, PostProcessingService } from '../../core/services';
import { StatMetric, TableViewComponentBase, TableViewQueryCriteria, TableViewQueryRequest } from '../../shared/components/table-view/table-view-component-base';
import { DialerCallLogRecord } from '../../core/models/dialer-call-log-record'
import { TestSeqService } from '../../core/services/test-seq.service';
import { TaskTypeName } from '../../core/models';
import { DialerClientTestSeqModalComponent } from '../../dialer-client/dialer-client-testseq/dialer-client-testseq-modal/dialer-client-testseq-modal.component';
import { TestDocArgs } from '../../path-test/path-test.component';


@Component({
  selector: 'app-dialer-call-logs-table',
  templateUrl: '../../shared/components/table-view/table-view.component.html',
  styleUrls: [
    '../../shared/components/table-view/scss/table-view.scss',
    '../../shared/components/table-view/scss/app-tab-full-height.scss',
    '../../shared/components/table-view/scss/fixed-headers-and-column.scss',
    './dialer-call-logs-table.component.scss'
  ]
})
export class DialerCallLogsTableComponent extends TableViewComponentBase<DialerCallLogRecord> implements OnInit, OnDestroy {

  constructor(
    public drivetestSeqService: DriveTestSeqService,
    public testSeqService: TestSeqService,
    public pathTestService: PathTestService,
    public bsModalService: BsModalService,
    public postProcessingService: PostProcessingService,
    appState: AppState,
    elementRef: ElementRef,
    datePipe: DatePipe
  ){
    super(appState,bsModalService,elementRef,datePipe)
    this.tableColumns  = [
      { title:'ID', name: 'id', visible: true},
      { title:'User ID', name: 'userid', visible: true},
      { title:'Dialer Box MAC', name: 'dialerboxmac', visible: true},
      { title:'Point ID', name: 'pointid', visible: true},
      { title:'Route ID', name: 'routeid', visible: true},
      { title:'Test Point ID', name: 'testpointid', visible: true},
      { title:'Sequence ID', name: 'seqid', visible: true},
      { title:'Start Time', name: 'starttime', visible: true, template: 'fulltime'},
      { title:'End Time', name: 'endtime', visible: true, template: 'fulltime'},
      { title:'Call Duration', name: 'duration', visible: true, template: 'fixed4'},
      { title:'Call Setup', name: 'setup', visible: true, template: 'fixed4'},
      { title:'Call Traffic', name: 'traffic', visible: true, template: 'fixed4'},
      { title:'Dialed Number', name: 'dialednum', visible: true},
      { title:'Phone MAC', name: 'phonemac', visible: true},
      { title:'Carrier', name: 'carrier', visible: true},
      { title:'Signal Percent', name: 'signalpct', visible: true},
      { title:'Bluetooth Ctr MAC', name: 'btctlmac', visible: true},
    ];
    this.sortColumns = [
      { key: 'starttime', order: 'DESC'},
      { key: 'id', order: 'ASC'},
    ];
    const metrics: StatMetric[] = [
      { column: 'setup', statTypes: ['min','max','avg']},
      { column: 'traffic', format: { dataType: 'number' }, statTypes: ['min','max','avg']},
      { column: 'duration', format: { dataType: 'number' }, statTypes: ['min','max','avg']},
      { column: 'starttime', format: { dataType: 'date' }, statTypes: ['min','max']},
      { column: '*', format: { dataType: 'number' }, statTypes: ['count']},
    ];
    this.statGroups = [
        {
          id: 'byCarrier',
          groupBy: ['carrier'], //,'pointid'],
          visible: true,
          metrics,
        },
        {
          id: 'dialerboxmac',
          groupBy: ['dialerboxmac'],
          metrics,
        },
        {
          id: 'dialednum',
          groupBy: ['dialednum'],
          metrics,
        },
        {
          id: 'phonemac',
          groupBy: ['phonemac'],
          metrics,
        },

    ];
  }


  ngOnInit(): void {
    this.init()
  }


  ngOnDestroy(): void {
    this.destroy()
  }

  doQuery = async ( queryReq:TableViewQueryRequest ) => this.postProcessingService.findDialerCallLogRecords(queryReq)

  showPoint(record:DialerCallLogRecord){
    this.showRequestFn( new ShowRequest('tab', 'point', record.pointid, null))
  }

  async showSequence(record:DialerCallLogRecord){
    this.isLoading = true
    try{
      const testSeqDoc = await this.testSeqService.getById(record.seqid)
      const pathTestDoc = await this.pathTestService.findOneByTestPointId(testSeqDoc.testPointId)
      const testPoint = pathTestDoc?.testPoints.find(tp=>tp.id==testSeqDoc.testPointId)
      const seq = testPoint.seqs.find(seq=>seq.dialerSeqId ==record.seqid)
      console.log(JSON.stringify(seq))
      const type : TaskTypeName = null // nothing in call record to indicate type
      const initialState = {
        seqContext: { seq, type }
      }
      DialerClientTestSeqModalComponent.showModal(this.bsModalService, initialState)

    } catch ( error: any ) {
      console.error(error)
      this.appState.publishError(error, this)
    }
    this.isLoading = false
  }

  showTestPoint = async (rec: DialerCallLogRecord) => {
    try {
      this.applySelectedRecords({recs: [rec]});
      const testDocArgs: TestDocArgs = {
        pointTestId: rec.testpointid,
        editPoint: true,
      }
      this.showRequestFn(new ShowRequest('tab', rec.routeid ? 'drive test' : 'path test', JSON.stringify(testDocArgs), null))
    } catch (e:any) {
      console.error(e);
      this.appState.notifyWarning('Could not get user details. ' + (e.message || e),this,3);
    }
  }

  showHandset = async (rec: DialerCallLogRecord) => {
    try {
      this.applySelectedRecords({recs: [rec]});
      const query: TableViewQueryCriteria = {
        page: {
          firstRowFilters: [ {
            key: 'btmac',
            value: rec.phonemac,
            mode: '='
          }]
        }
      }
      this.showRequestFn(new ShowRequest('tab', 'handsets', JSON.stringify(query), null))
    } catch (e:any) {
      console.error(e);
      this.appState.notifyWarning('Could not get user details. ' + (e.message || e),this,3);
    }
  }


}
